import { generateUnOrderedList, getCircleTypeListItem, getSquareTypeListItem } from "../../../screens/JaldiLab/Chapters/ChapterList"

export const ImageDesc51 = {
    title: "Image 51: Example of accessible seating in waiting areas.",
    para1: "The image shows four chairs in a waiting area. The right-most chair is an accessible chair. The chair is raised higher than the other three chairs and the signage on it shows an accessibility sign, a person with crutches and a pregnant person."
}

export const ImageDesc52 = {
    title: "Image 52:  Examples of Feeding Rooms in Waiting Areas.",
    para1: <>
        <p>This image shows two examples of parts of a feeding room. The picture on top shows a bright and clean bathroom with a white changing table mounted on the wall beneath a rectangular mirror. There is a white porcelain sink with a chrome faucet to the right of the changing table. Next to the sink is a white soap dispenser. To the left of this room, there is a corridor from which two other rooms are partially visible. One of the rooms has a yellow sofa and the other has a white wall-mounted diaper changing station. </p>
        <p>The picture below a changing room with a clean white surface that has changing tables and a sinks  beside it. The walls have a wall painting showing mountains in soothing black, grey and yellow colours. There is a vending machine on the right wall that dispenses diapers.</p>
    </>
}

export const FigureDesc41 = {
    title: "Figure 41: Typical floor plan for a general waiting area. ",
    para1: <>
        <p>
            <span><b>Orientation of the floor plan: </b></span>
            The entrance is positioned at the bottom centre of the floor plan. The waiting area includes a child play area, waiting room, feeding room, quiet room, and washrooms. These features are described space by space.
        </p>
        <p>
            <span><b>Description: </b></span>
            <div className="figure_desc">
                {generateUnOrderedList([
                    <>
                        Child play area:
                        {getCircleTypeListItem([
                            "A child play area has been provided at the right side, upon entering the waiting area.",
                            "This area has accessible child-friendly facilities.",
                        ])}
                    </>,
                    <>
                        Waiting room:
                        {getCircleTypeListItem([
                            "The waiting room measures 9000 mm x 15000 mm.",

                            "Two information kiosks are provided to the bottom right of the waiting room.",

                            "Seating facilities are provided in two horizontal and five vertical rows. The rows are separated by a width of 900 mm, and the horizontal and vertical seating provisions are separated by a width of 1300 mm.",

                            "The seating facilities include provisions for wheelchair-accessible seating at the end of the rows.",

                            "An elevated case display board is present at the bottom side of the waiting room, in a manner which ensures that it is visible to all users who are seated in the room.",

                            "Pantry facilities are provided at the back of the waiting room.",
                        ])}
                    </>,
                    <>
                        Feeding room:
                        {getCircleTypeListItem([
                            "A feeding room (2500 mm x 2500 mm) with signage is provided at the top left corner of the waiting area.",
                            "The feeding room is accessible, well ventilated with a window and has a chair and a small table for storing necessities.",

                        ])}
                    </>,
                    <>
                        Quiet room:
                        {getCircleTypeListItem([
                            "A quiet room (2200 mm x 2500 mm) with signage is provided directly below the feeding room.",
                            "The quiet room consists of comfortable sofas, sensory boards and other amenities required.",

                        ])}
                    </>,
                    <>
                        Washrooms:
                        {getCircleTypeListItem([
                            <>
                                The waiting area makes provisions for attached male, female, and gender-neutral washrooms. The features of the washrooms are described in a clockwise manner:
                                {getSquareTypeListItem([
                                    <>
                                        Female washrooms (8850 mm x 4500 mm):
                                        <div className="figure_desc">
                                        {generateUnOrderedList([
                                            "Space has been provided within the entrance for a wall mounted dustbin, changing station, clothes hook and a hand dryer.",

                                            "To the left of the hand dryer is the first cubicle. Three adjacent cubicles have been provided in total.",

                                            "The first cubicle has an Indian water closet.",

                                            "To the left of this cubicle is the Western water closet.",

                                            "To the left of this second cubicle is an accessible toilet. There is a basin inside the accessible toilet along with a Western water closet, with a turning diameter of 1500 mm.",

                                            "In front of the three cubicles are five washbasins.",

                                        ])}
                                        </div>
                                    </>,

                                    <>
                                        Gender-neutral washrooms (2350 mm x 2750 mm):
                                        <div className="figure_desc">
                                        {generateUnOrderedList([
                                            "The gender neutral washroom is below the female washroom.",
                                            "To the left of the entrance, there is an adult size diaper changing station.",
                                            "The washroom has a western Water Closet, washbasin and clothes hook."

                                        ])}
                                        </div>
                                    </>,

                                    <>
                                        Male washrooms (8850 mm x 4500 mm):
                                        <div className="figure_desc">
                                        {generateUnOrderedList([
                                            "The male washrooms are below the gender-neutral washrooms and are separated from the female washrooms by an aisle space.",
                                            "The male washrooms have the same facilities and dimensions as the female washrooms. ",

                                        ])}
                                        </div>
                                    </>,
                                ])}
                            </>,
                        ])}
                    </>,
                ])}
            </div>
        </p>
    </>
}

export const FigureDesc42 = {
    title: "Figure 42: Typical floor plan for waiting areas in corridors.",
    para1: <>
        <p>
            <span><b>Orientation of the Floor Plan: </b></span>
            The figure shows a floor plan of a corridor in the Court Complex, surrounded by a Courtroom, Ahlmad Room, three Administrative Offices and a space for staircases leading towards a Waiting Room. The entrance to the corridor waiting area is on the left side of the figure. The features are described space by space, in a clockwise manner from the entry.
        </p>
        <p>
            <span><b>Description: </b></span>
            <div className="figure_desc">
                {generateUnOrderedList([
                    "The entrance to the corridor waiting area is provided on the left side. The entrance is wheelchair accessible, with a width of 2000 mm. ",

                    <>
                        Enclosed spaces surrounding the corridor:
                        {getCircleTypeListItem([
                            <>
                                Courtroom and Ahlmad Room:
                                {getSquareTypeListItem([
                                    "The corridor is bounded at the top-left and the top-middle by a Courtroom and an Ahlmad Room.",
                                    "Upon entering, one of the walls of a Courtroom is shown to the left. A door opens from the space demarcated for the Courtroom onto the corridor waiting area.",
                                    "An Ahlmad Room adjoins the right side of the Courtroom.",

                                ])}
                            </>,

                            <>
                                Administrative Office:
                                {getSquareTypeListItem([
                                    "Space is demarcated for an Administrative Office at the top-right, adjoining the Ahlmad Room, with an accessible entrance (width 2000 mm) and CCTV facility right outside the entrance to the Administrative Office. "
                                ])}
                            </>,

                            <>
                                Staircase and Towards Waiting Room:
                                {getSquareTypeListItem([
                                    "The right of the figure is a space of width 4350 mm demarcated for accessible staircases at the top of the enclosed space, leading up from a lower level, with space for wheelchair storage. The wheelchair storage is of length 2300 mm and width 1050 mm.",
                                    "At the bottom of the enclosed space and directly opposite the staircase, two lifts are provided.",
                                    "A clear space is provided between the staircase and the lifts, and has a door leading into the corridor waiting area in the middle of the figure on the left and a door leading towards a waiting room on the right side.",

                                ])}
                            </>,

                            <>
                                Administrative Office:
                                {getSquareTypeListItem([
                                    "A second Administrative Office is provided at the bottom-left.",
                                    "A part of a third Administrative Office is depicted above the second Administrative Office, at an accessible distance of width 1500 mm. Here, R.F.I.D. controlled access for entry/exit to the corridor waiting area is provided. The other half of the third Administrative Office extends beyond the left and is not shown in the figure.",
                                    "An open space is provided in front of the third Administrative Office.",

                                ])}
                            </>,


                        ])}
                    </>,

                    <>
                        Corridor Waiting Area:
                        {getCircleTypeListItem([
                            "At the top of the corridor, space is provided for facilities for standing while waiting.",
                            "Along the right side of the corridor, seating facilities, including wheelchair-accessible seating, are provided in 3 sets of 5 chairs each. A dustbin is also provided in between two seating sets.",
                            "At the bottom of the corridor, green plants and drinking water provisions are available.",
                            "Along the left side of the corridor, another set of 5 chairs including wheelchair-accessible seating is provided.",

                        ])}
                    </>
                ])}
            </div>
        </p>
    </>
}

export const FigureDesc43 = {
    title: "Figure 43: Typical floor plan for an accused waiting room.",
    para1: <>
        <p>
            <span><b>Orientation of the floor plan: </b></span>
            This figure shows the layout of the accused waiting area which should be provided on every floor of the Court Complex. The dimensions of the waiting area recommended in this Handbook is 4000 mm x 3600 mm. The dimensions should be altered as per the needs of the Court Complex.
        </p>
        <p>
            The entrance to the accused waiting room is provided at the bottom-left of the document. The features of the room are described space by space.
        </p>
        <p>
            <span><b>Description: </b></span>
            <div className="figure_desc">
                {generateUnOrderedList([
                    "There is a provision for PI seating outside the accused waiting room.",

                    "The lobby outside the waiting room has a CCTV camera monitoring the area.",

                    "The entrance is on the bottom left corner of the room. This entrance leads to the accused waiting room. The entrance to the accused waiting room has controlled access.",

                    "The gate has a bean slot such that food may be provided to the accused when necessary.",

                    "A bench for seating is provided on the right side of the room along with a seating provision for a  wheelchair.",

                    "There is a space provided inside the waiting room on the top left corner of the room which leads to the toilets and drinking water facilities. The pathway leading up to the drinking water facilities has a width of 1500 mm.",

                    "There is provision for drinking water in complete view of the PI seating.",

                    "On its right, there is a door that leads towards a washroom.",

                    "The washroom is accessible with a turning diameter of 1500 mm. It has an Indian water closet and a basin.",

                    "The room has two CCTV cameras to monitor the area.",

                ])}
            </div>
        </p>
    </>
}



